import { API_URL } from '../config';
import { getData } from './http';

export const getLanguages = async () => getData(`${API_URL}/languages`);
